import React, { useLayoutEffect } from "react";
import { Row, Col, Button, Form, Space, Select } from "antd";
import { Controller, set, useForm } from "react-hook-form";
import { DateField, InputField, InputAutocompleteField, SelectField } from "../../../../atoms/FormElement";
import { datePlaceholderddmmyyFormat } from "../../../BookingForm/components/utils";

export default React.memo((props: any) => {
  const { control, handleSubmit, setValue, reset } = useForm({});
  const [screenSize, setScreenSize] = React?.useState("");
  const clearedType = [
    { value: "cleared", label: "Cleared" },
    { value: "not_cleared", label: "Not Cleared" },
  ];

  useLayoutEffect(() => {
    const checkScreenSize = () => {
      const width = window.innerWidth;
      if (width >= 1500) {
        setScreenSize("xl");
      } else if (width >= 992) {
        setScreenSize("lg");
      } else {
        setScreenSize("smaller than lg");
      }
    };

    // Initial check
    checkScreenSize();
    // Add event listener to update on resize
    window.addEventListener("resize", checkScreenSize);
    // Clean up the event listener on unmount
    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  const {
    setDateTo,
    setDateFrom,
    setChequeDateTo,
    setChequeDateFrom,
    setPaymentRefFilter,
    setTenantNameFilter,
    setBankRefFilter,
    chequeDateFrom,
    chequeDateTo,
    filterReset,
    onAfterFilterSubmit,
    buOptions,
    onBUSelect,
    resetLandloard,
    buFilterOption,
    setInvoiceNumber,
    setIsCleared,
    isCleared,
  } = props;

  const onFilterSubmit = (e) => {
    if (screenSize === "lg") {
      setDateFrom(e.dueDateFrom === "" ? null : e.dueDateFrom);
      setDateTo(e.dueDateTo === "" ? null : e.dueDateTo);
    }

    setChequeDateTo(e?.chequeDateTo === "" ? null : e?.chequeDateTo);
    setChequeDateFrom(e?.chequeDateFrom === "" ? null : e?.chequeDateFrom);
    setBankRefFilter(e?.bankRef === "" ? null : e?.bankRef);
    setPaymentRefFilter(e?.paymentRef === "" ? null : e?.paymentRef);
    setTenantNameFilter(e?.tenantName === "" ? null : e?.tenantName);
    setInvoiceNumber(e?.inviceNumber === "" ? null : e?.inviceNumber);
    onAfterFilterSubmit?.();
  };

  const resetAllFields = () => {
    reset();
    // setValue("chequeDateFrom", null);
    // setValue("chequeDateTo", null);
    // setValue("paymentRef", null);
    // setValue("tenantName", null);
    // setValue("bankRef", null);
    // setValue("inviceNumber", null);
    setIsCleared(null);
    // setValue("clearedStatus", { label: "", value: null });
    // if (buOptions?.[0]?.name) setValue(buOptions[0].name, null);
    filterReset();
  };

  return (
    <Form layout="vertical" className="bf-main" onFinish={handleSubmit((e) => onFilterSubmit(e))}>
      <Row gutter={6}>
        {buOptions && buOptions.length > 0 && (
          <Col span={24}>
            <InputAutocompleteField
              initValue={buOptions[0].defaultValue}
              onSelect={onBUSelect}
              filterOption={buFilterOption}
              options={buOptions[0].options}
              fieldname={buOptions[0].name}
              label={buOptions[0].label}
              control={control}
              style={{ width: "100%" }}
              setValue={setValue}
              iProps={{ placeholder: buOptions[0].placeholder }}
              valueGot={resetLandloard?.includes("reset") && ""}
            />
          </Col>
        )}

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Cheque Date From"
            fieldname="chequeDateFrom"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Date From",
            }}
            valueGot={chequeDateFrom}
          />
        </Col>

        <Col span={12}>
          <DateField
            control={control}
            setValue={setValue}
            label="Cheque Date To"
            fieldname="chequeDateTo"
            iProps={{
              format: datePlaceholderddmmyyFormat,
              placeholder: "Date To",
            }}
            valueGot={chequeDateTo}
          />
        </Col>

        <Col span={12}>
          <InputField
            fieldname="paymentRef"
            label={"Payment Ref"}
            control={control}
            iProps={{
              placeholder: "Payment Ref",
            }}
            initValue=""
          />
        </Col>

        <Col span={12}>
          <InputField
            fieldname="bankRef"
            label={"Bank"}
            control={control}
            iProps={{
              placeholder: "Bank",
            }}
            initValue=""
          />
        </Col>

        <Col span={12}>
          <InputField
            fieldname="tenantName"
            label={"Tenant Name"}
            control={control}
            iProps={{
              placeholder: "Tenant Name",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <InputField
            fieldname="inviceNumber"
            label={"Invoice No"}
            control={control}
            iProps={{
              placeholder: "Invoice No",
            }}
            initValue=""
          />
        </Col>
        <Col span={12}>
          <>
            <Form.Item label={`Cleared Status`}>
              <Select
                className="cleared-custom-select"
                value={isCleared}
                style={{ borderRadius: "6px" }}
                onChange={(e) => setIsCleared(e)}
                placeholder={`Cleared Status`}
                size="large"
                options={clearedType}
              />
            </Form.Item>
          </>
        </Col>
        <Col span={24}>
          <Space style={{ position: "fixed", bottom: "10px", right: "5px" }}>
            <Button size={"small"} style={{ marginTop: "10px" }} className="ef-approve-btn" htmlType="submit">
              {"Submit"}
            </Button>

            <Button
              size={"small"}
              style={{ marginTop: "10px" }}
              onClick={() => resetAllFields()}
              className="ef-reject-btn"
              htmlType="button"
            >
              {"Reset"}
            </Button>
          </Space>
        </Col>
      </Row>
    </Form>
  );
});
